export const siteInfo = {
  name: "511爆料",
  slogan: "让每一条爆料都有回应",
  intro:
    "511爆料是一个面向大众的匿名投稿与瓜料分享平台。我们把入口做得足够简单，也把审核做得足够认真：每条线索直达后台人工复核，投稿人身份默认脱敏，瓜料被采纳后进入热门发酵环节，持续跟进与回应。",
  email: "tip@511baoliao.example.com",
  bizEmail: "partner@511baoliao.example.com",
  workingHours: "每日 09:00 - 23:00（审核轮值）",
  stats: [
    { label: "累计收到线索", value: "128,400+" },
    { label: "已采纳瓜料", value: "9,760+" },
    { label: "平均审核时长", value: "38 分钟" },
    { label: "投稿隐私投诉", value: "0 起" },
  ],
};

export const navItems = [
  { path: "/", label: "首页" },
  { path: "/square", label: "爆料广场" },
  { path: "/submit", label: "我要爆料" },
  { path: "/faq", label: "常见问题" },
  { path: "/about", label: "关于我们" },
];

export const hotKeywords = [
  "顶流恋情",
  "综艺内幕",
  "剧组换角",
  "带货翻车",
  "新剧路透",
  "代言解约",
  "直播争议",
  "幕后工作人员",
];

export const submissionChannels = [
  {
    id: "private",
    icon: "ri-chat-private-line",
    title: "私信投稿",
    desc: "把线索整理成一段话，私信发送即可。适合短小的现场见闻与及时瓜料。",
  },
  {
    id: "form",
    icon: "ri-file-text-line",
    title: "表单投喂",
    desc: "通过投稿表单填写标题、类型与细节，可附上时间线，适合信息量较大的爆料。",
  },
  {
    id: "oneclick",
    icon: "ri-flashlight-line",
    title: "一键爆料",
    desc: "不想写长文？选择领域标签，一句话说清核心信息，剩下的交给后台整理。",
  },
  {
    id: "followup",
    icon: "ri-refresh-line",
    title: "持续补充",
    desc: "线索进入发酵后仍可继续补充材料，同一爆料支持多次追加，避免信息断层。",
  },
];